module.exports = "//public.getcloudapp.com/packs/media/images/annotate/square-focus-2536a862a2cea069a5013730c90daa67.svg";